import script from "./heading-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./heading-box.vue?vue&type=script&setup=true&lang=ts"

import "./heading-box.vue?vue&type=style&index=0&id=1b021e91&lang=scss"

const __exports__ = script;

export default __exports__